import React from 'react';

const AIActivityTimeline = ({ rows = [], variant = 'dark', onRowClick }) => {
  const isLight = variant === 'light';
  const buildRowHandlers = (row) => {
    if (typeof onRowClick !== 'function') {
      return {};
    }
    return {
      role: 'button',
      tabIndex: 0,
      onClick: () => onRowClick(row),
      onKeyDown: (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onRowClick(row);
        }
      },
    };
  };
  return (
    <div className="space-y-4">
      {rows.map((row, index) => (
        <div key={row.id || `${row.title}-${index}`} className="flex gap-4">
          <div className="flex flex-col items-center">
            <div className={`h-3 w-3 rounded-full ${isLight ? 'bg-primary shadow-[0_0_0_6px_rgba(8,110,244,0.12)]' : 'bg-cyan-300 shadow-[0_0_0_6px_rgba(34,211,238,0.12)]'}`} />
            {index !== rows.length - 1 && <div className={`mt-2 h-full w-px ${isLight ? 'bg-border' : 'bg-slate-700/80'}`} />}
          </div>
          <div
            className={isLight ? `w-full rounded-2xl border border-border bg-card p-4 text-foreground shadow-sm ${typeof onRowClick === 'function' ? 'cursor-pointer transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary/40' : ''}` : `w-full rounded-2xl border border-slate-700/80 bg-slate-950/90 p-4 text-slate-100 shadow-[0_14px_40px_rgba(2,6,23,0.24)] backdrop-blur-sm ${typeof onRowClick === 'function' ? 'cursor-pointer transition-colors hover:bg-slate-900/95 focus:outline-none focus:ring-2 focus:ring-cyan-400/40' : ''}`}
            {...buildRowHandlers(row)}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className={`text-sm font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{row.title || row.policy_name}</p>
                <p className={`mt-1 text-sm ${isLight ? 'text-foreground' : 'text-slate-200'}`}>{row.subtitle || row.event_type || row.meta}</p>
              </div>
              <p className={`text-xs ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>{row.created_at ? new Date(row.created_at).toLocaleString() : ''}</p>
            </div>
            {row.meta && <p className={`mt-3 text-xs uppercase tracking-[0.18em] ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>{row.meta}</p>}
          </div>
        </div>
      ))}
      {rows.length === 0 && <div className={`rounded-2xl border border-dashed p-6 text-center text-sm ${isLight ? 'border-border text-muted-foreground' : 'border-slate-700/80 text-slate-300'}`}>No AI activity yet.</div>}
    </div>
  );
};

export default AIActivityTimeline;
